import { render, staticRenderFns } from "./boa-hora.vue?vue&type=template&id=3872f933&scoped=true&"
import script from "./boa-hora.vue?vue&type=script&lang=ts&"
export * from "./boa-hora.vue?vue&type=script&lang=ts&"
import style0 from "./boa-hora.vue?vue&type=style&index=0&id=3872f933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872f933",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage})
